module.exports = __webpack_public_path__ + "img/chart.e4ebb2a6.svg";